document.addEventListener('click',event=>{const button=event.target.closest('[data-s2-expand]');if(!button)return;const content=document.getElementById(button.getAttribute('aria-controls'));if(!content)return;const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));content.classList.toggle('is-expanded',!expanded);button.textContent=expanded?button.dataset.more:button.dataset.less;});

let s2RandomBusy=false;
window.ShirtyDiscovery={next:async button=>{
 if(s2RandomBusy)return;
 const config=document.getElementById('s2-random-config');if(!config)return;
 s2RandomBusy=true;button.disabled=true;button.setAttribute('aria-busy','true');
 const root=config.dataset.root.replace(/\/?$/,'/');
 try{
  let pool=[];try{pool=JSON.parse(sessionStorage.getItem('shirty-random-pool-v4-'+config.dataset.country)||'[]')}catch(error){}
  if(!Array.isArray(pool))pool=[];
  const current=location.pathname.split('/products/')[1]?.split('/')[0];pool=pool.filter(h=>h!==current);
  if(!pool.length){
   const page=1+Math.floor(Math.random()*Math.max(1,Math.ceil(Number(config.dataset.count)/250)));
   const response=await fetch(root+'collections/all/products.json?limit=250&page='+page+'&country='+encodeURIComponent(config.dataset.country));
   if(!response.ok)throw new Error('catalog');
   const data=await response.json();pool=(data.products||[]).filter(p=>p.handle!==current&&p.variants.some(v=>v.available)).map(p=>p.handle);
  }
  if(!pool.length)throw new Error('empty');
  const handle=pool.splice(Math.floor(Math.random()*pool.length),1)[0];
  try{sessionStorage.setItem('shirty-random-pool-v4-'+config.dataset.country,JSON.stringify(pool))}catch(error){}
  const destination=new URL(root+'products/'+encodeURIComponent(handle),location.origin);destination.searchParams.set('country',config.dataset.country);location.assign(destination.href);
 }catch(error){let status=document.getElementById('s2-random-status');if(!status){status=document.createElement('span');status.id='s2-random-status';status.setAttribute('role','status');button.after(status)}status.textContent=config.dataset.error;s2RandomBusy=false;button.disabled=false;button.removeAttribute('aria-busy');}
}};
window.addEventListener('pageshow',()=>{s2RandomBusy=false;document.querySelectorAll('.s2-random-nav').forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy')})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.s2-market[open]').forEach(d=>d.removeAttribute('open'))});
document.addEventListener('click',event=>{document.querySelectorAll('.s2-market[open]').forEach(d=>{if(!d.contains(event.target))d.removeAttribute('open')})});



(function(){
 const config=window.ShirtyUIStrings;
 if(!config||!config.nav)return;
 const language=document.documentElement.lang.split('-')[0];
 if(!['en','no','nb'].includes(language))return;
 const labels=config.nav,root=config.root.replace(/\/?$/,'/');
 function translate(scope){
  document.querySelectorAll('nav').forEach(nav=>{
   if(scope!==document&&!nav.contains(scope)&&!scope.contains(nav))return;
   const walker=document.createTreeWalker(nav,NodeFilter.SHOW_TEXT);let node;
   while(node=walker.nextNode()){
    if(node.parentElement.closest('script,style'))continue;
    const original=node.nodeValue,key=original.trim();
    if(labels[key]&&labels[key]!==key)node.nodeValue=original.replace(key,labels[key]);
   }
   nav.querySelectorAll('[aria-label],[title]').forEach(el=>{
    ['aria-label','title'].forEach(attr=>{
     const value=el.getAttribute(attr);if(!value)return;
     if(labels[value])el.setAttribute(attr,labels[value]);
     else if(value.endsWith(' submenu')){const key=value.slice(0,-8);if(labels[key])el.setAttribute(attr,labels[key]+' '+config.submenu)}
    });
   });
   nav.querySelectorAll('a[href]').forEach(a=>{
    const url=new URL(a.href,location.origin);
    if(url.origin!==location.origin||!/^\/(collections|products|pages|blogs)(\/|$)/.test(url.pathname))return;
    a.href=root+url.pathname.slice(1)+url.search+url.hash;
   });
  });
 }
 const pending=new Set();let frame=0;
 function queue(scope){pending.add(scope);if(frame)return;frame=requestAnimationFrame(()=>{frame=0;pending.forEach(translate);pending.clear()})}
 function start(){translate(document);new MutationObserver(records=>{records.forEach(r=>{if(r.target.nodeType===1)queue(r.target)})}).observe(document.body,{childList:true,subtree:true})}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
